import React, { useEffect, useState, useRef } from 'react'
import styled from '@emotion/styled'
import { Global, css } from '@emotion/react'
import WebComponentContainer from '../generic/WebComponentContainer'
import useEventBus from '../generic/useEventBus'
import { useScrollManagement, useFocusManagement } from '../../hooks'

export default ({ vehicleName, trim, vin, currentStep, pages, stepClick, mileage, theme }) => {
  const [pageLoaded, setPageLoaded] = useState(false)
  const [showLoader, setShowLoader] = useState(true)
  const breadcrumbRef = useRef(null)

  // Initialize page loading state
  useEffect(() => {
    setPageLoaded(true)
    setShowLoader(false)
  }, [])

  // Use custom hooks for scroll and focus management
  useScrollManagement(currentStep, breadcrumbRef)
  useFocusManagement(currentStep, breadcrumbRef)

  ////// **** - Integrated Breadcrumb Code - **** //////
  useEventBus('NavigateToPage', event => {
    stepClick(pages[event.index], event.index)
  })

  return (
    <>
      <Global styles={GlobalBreadcrumbStyles} />
      <WebComponentContainer pageLoadingComplete={pageLoaded} withLoader={showLoader} maxWidth="100%" location={'breadcrumb'} theme={theme}>
        <BreadcrumbContainer ref={breadcrumbRef} tabIndex="-1">
          <ico-breadcrumb vin={vin} vehicle-y-m-m={vehicleName} trim={trim} is-branded={true} current-page={currentStep} mileage={mileage} theme={theme} />
        </BreadcrumbContainer>
      </WebComponentContainer>
    </>
  )
}

const BreadcrumbContainer = styled.div`
  outline: none;
  transition: all 0.3s ease-in-out;
  position: relative;
`
const GlobalBreadcrumbStyles = css`
  #WebComponentContainer-breadcrumb:focus-visible {
    outline: none !important;
  }
`
